/**
 * Check if the current domain is the test domain (usubt.com)
 * @returns true if on usubt.com, false otherwise
 */
export const isTestDomain = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const hostname = window.location.hostname;
  return hostname === 'usubt.com' || hostname.includes('usubt.com') || hostname.includes('usub-devtest');
};

/**
 * Check if the current domain is the production domain (usublease.com)
 * @returns true if on usublease.com, false otherwise
 */
export const isProductionDomain = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const hostname = window.location.hostname;
  return (
    hostname === 'usublease.com' ||
    hostname.includes('usublease.com') ||
    hostname === 'usub.net' ||
    hostname.includes('usub.net')
  );
};

/**
 * Check if the current domain is the admin domain (usubx.com)
 * @returns true if on usubx.com, false otherwise
 */
export const isAdminDomain = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const hostname = window.location.hostname;
  // Check for usubx.com or usub-admin domains
  return hostname === 'usubx.com' || hostname.includes('usubx.com') || hostname.includes('usub-admin');
};





